var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuteAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    iconName: "IconPersonAdvertiserFill",
    className: "css-6xix1i",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13a10 10 0 1 1 20 0 10 10 0 0 1-20 0ZM2 40.44C2 33.92 8.06 26 19 26c3.43 0 6.38.78 8.82 2.05-.52.98-.82 2.1-.82 3.28v5.95a7 7 0 0 0 4.79 6.64C30.54 44 28.97 44 27 44H11c-7 0-9 0-9-3.56ZM45.7 23.66c0-1.8-2.22-2.64-3.41-1.29l-4.84 5.49a2.3 2.3 0 0 1-1.73.77H34a2.7 2.7 0 0 0-2.7 2.7v5.95c0 1.49 1.2 2.7 2.7 2.7h1.83c.62 0 1.22.25 1.65.7l4.87 5.05a1.95 1.95 0 0 0 3.35-1.35V23.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteAds);
export default __webpack_public_path__ + "static/media/mute-ads.f9d550eef76826b688997f3be975e9c8.svg";
export { ForwardRef as ReactComponent };